<button mat-icon-button value="Join Session" (click)="openChat()">
  Join Session
</button>
